import React, {Fragment} from "react";

export default ({results}) => {
    if (results.length === 0) {
        return '';
    }
    return <Fragment>
        <h2>Likely Results</h2>
        <div className="problem-solver__sidebar__list">
            {results.map((insect) => {
                return <div className="problem-solver__sidebar__item" key={'likely__' + insect.id}>
                    <a href={insect.link}>
                        <div className="problem-solver__sidebar__item__image"
                             style={{ backgroundImage: 'url(' +  insect.insect_image + ')'}}
                        ></div>
                        <div className="problem-solver__sidebar__item__body">
                            <h3>{insect.title}</h3>
                            <p>
                                {insect.summary} <span>Read more ></span>
                            </p>
                        </div>
                    </a>
                </div>;

            })}
        </div>
    </Fragment>


}
